import React, { useState } from 'react'
import styles from './STAnnouncementBanner.scss'
import { NoticePanel } from 'common/layouts/ThreePanelLayout'
import { NoticeBar } from 'common/styleguide/NoticeBar'
import { useFormatMessage, Msg, commonVerbs } from 'lib/localization'
import { defineMessages } from 'react-intl'

export const ST_BANNER_DISMISSED = 'ST_BANNER_DISMISSED'

const messages = defineMessages({
  stComingV2: {
    id: 'STAnnouncementBanner.stComingV2',
    defaultMessage: `
    <a1>Surface Types</a1> is coming! Spot a mistake? We'd really appreciate your <a2>feedback</a2> as we launch this new feature.
    `
  },
  feedbackSubject: {
    id: 'STAnnouncementBanner.feedbackSubject',
    defaultMessage: 'Surface types feedback'
  }
})

export const STAnnouncementBanner = ({ setPreference, planner, forceUpdate }) => {
  const fm = useFormatMessage()
  const [dismissed, setDismissed] = useState(false)
  const dismiss = () => {
    setPreference(ST_BANNER_DISMISSED, true)
    setDismissed(true)
  }

  if (dismissed) {
    return null
  }

  const contents = <div id='rp_nudge' className={styles.contents}>
    <span>
      {fm(messages.stComingV2, {
        a1: (...c) => <a href='/help/surface-types' target='_blank'>{c}</a>,
        a2: (...c) => <a href={`mailto:info@ridewithgps.com?subject=${fm(messages.feedbackSubject)}`}>{c}</a>
      })}
    </span>
    <a onClick={dismiss} style={{ marginLeft: '10px' }}><Msg m={commonVerbs.dismiss} capitalized /></a>
  </div>

  if (planner) {
    const plannerProps = {
      contents
    }
    return <PlannerAnnouncement {...plannerProps} />
  }

  return (
    <NoticePanel>
      {contents}
    </NoticePanel>
  )
}

const PlannerAnnouncement = ({ contents }) => {
  return <NoticeBar>
    {contents}
  </NoticeBar>
}
